export { GradientParser } from './common/color-utils';
